/* FAKTY ZE SHOPIFY: cena w walucie rynku, dostepnosc, rozmiar, zdjecie.
   Jeden klient dla PDP („podobne pary") i dla cross-sellu w koszyku - obie sciezki
   pytaja o to samo, wiec pytaja tym samym kodem.

   🚨 PO CO (2026-08-13): PIM ustala KOLEJNOSC propozycji i zostaje silnikiem doboru,
   ale cena/waluta/dostepnosc musza isc ze Shopify. PIM zwraca zlotowki, wiec na rynku
   EUR wychodzila liczba w PLN z obcym symbolem (cross-sell byl tam wylaczony), a lista
   potrafila niesc pare juz sprzedana albo skasowana.

   Kanal: Section Rendering API na sekcji `snkl-fakty` (patrz sections/snkl-fakty.liquid).
   Cena przychodzi SFORMATOWANA przez Liquid - JS nigdy nie sklada waluty samodzielnie.

   API:
     SnklFakty.dla(['handle-a','handle-b'])  -> Promise<[fakt|null, ...]>  (kolejnosc wejscia)
     SnklFakty.filtr({'filter.v.option.size':'42', ...}) -> Promise<[fakt, ...]>
   Fakt: {handle, tytul, marka, cena, grosze, dostepna, rozmiar, obraz, url}
*/
(function () {
  if (window.SnklFakty) return;

  var SEKCJA = 'snkl-fakty';
  var pamiec = {};

  function korzen() {
    return ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  }

  /* podglad motywu trzyma sie ciasteczka, ale przy pierwszym wejsciu z linku
     ?preview_theme_id=... ciasteczka jeszcze nie ma i fetch poszedlby do LIVE */
  function podglad() {
    var m = location.search.match(/[?&](preview_theme_id=\d+)/);
    return m ? '&' + m[1] : '';
  }

  function pobierz(sciezka) {
    var url = korzen() + sciezka + (sciezka.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + SEKCJA + podglad();
    return fetch(url, { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) {
        // sekcja przychodzi owinieta w <div id="shopify-section-...">
        var a = t.indexOf('{"lista"');
        var b = t.lastIndexOf(']}');
        if (a < 0 || b < a) return [];
        try {
          var d = JSON.parse(t.slice(a, b + 2));
          return (d && d.lista) || [];
        } catch (e) { return []; }
      })
      .catch(function () { return []; });
  }

  function jeden(handle) {
    if (!handle) return Promise.resolve(null);
    if (!pamiec[handle]) {
      pamiec[handle] = pobierz('/products/' + encodeURIComponent(handle)).then(function (l) {
        return l[0] || null; // 404 / skasowany produkt = null, wypada z listy
      });
    }
    return pamiec[handle];
  }

  window.SnklFakty = {
    dla: function (handles) {
      return Promise.all((handles || []).map(jeden));
    },
    filtr: function (params) {
      // 🚨 SNKL 2026-09-06: wartoscia moze byc TABLICA. Filtry Shopify sumuja
      // powtorzone klucze przez LUB (`filter.v.option.size=43&filter.v.option.size=43.5`),
      // wiec cala drabinka rozmiarow miesci sie w JEDNYM zadaniu zamiast w kilku.
      var q = Object.keys(params || {})
        .filter(function (k) {
          var v = params[k];
          return Array.isArray(v) ? v.length : v;
        })
        .map(function (k) {
          var v = params[k];
          if (!Array.isArray(v)) return encodeURIComponent(k) + '=' + encodeURIComponent(v);
          return v.map(function (x) { return encodeURIComponent(k) + '=' + encodeURIComponent(x); }).join('&');
        })
        .join('&');
      if (!q) return Promise.resolve([]);
      return pobierz('/collections/all?' + q).then(function (l) {
        // do pamieci, zeby druga warstwa fallbacku nie pytala drugi raz o te same pary
        l.forEach(function (f) { if (f && f.handle) pamiec[f.handle] = Promise.resolve(f); });
        return l;
      });
    }
  };
})();
